module.exports = __webpack_public_path__ + "img/llevamos.f10e039b.png";